// extracted by mini-css-extract-plugin
export var actions = "_si-4";
export var item = "_si-1";
export var price = "_si-3";
export var quantity = "_si-2";
export var table = "_si-0";